import request from './request'

//推荐岗位添加
export function addRecommend(data) {
  return request({
    url: '/api/recommend/add',
    method: 'post',
    data
  })
}

// 获取更多岗位
export function getMoreList(params) {
  return request({
    url: '/api/recommend/moreList',
    method: 'get',
    params
  })
}

// 获取推荐岗位任务ID
export function getRecommendId(data) {
  return request({
    url: '/api/recommend/getRecommendId',
    method: 'post',
    data
  })
}
// 获取推荐结果json
export function getGenerateJson(data) {
  return request({
    url: '/api/recommend/getGenerateJson',
    method: 'post',
    data
  })
}

// 获取推荐结果
export function getRecommendResult(params) {
  return request({
    url: '/api/recommend/getRecommendResult',
    method: 'get',
    params
  })
}

export function addPhone(data) {
  return request({
    url: '/api/consult',
    method: 'post',
    data
  })
}

export function getRecommendVideo(data) {
  return request({
    url: '/api/recommend/getRecommendVideo',
    method: 'post',
    data
  })
}


//热门岗位推荐/api/search/hotJobs
export function getHotJob(data) {
  return request({
    url: '/api/search/hotJobs',
    method: 'post',
    data
  })
}

//根据面试id获取面试结果
export function getFeedbackByInterviewId(params) {
  return request({
    url: '/api/interview/getInterviewAnalysis',
    method: 'get',
    params,
  })
}
